import React, { createContext, useContext, useEffect, useState } from 'react';

type DialogContextType = {
    openDialog: (name: string, data?: unknown) => void;
    closeDialog: (name: string) => void;
    isDialogOpen: (name: string) => boolean;
    getDialogData: () => unknown;
    data?: unknown;
};

const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const DialogProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [dialogIsOpen, setDialogIsOpen] = useState<Record<string, boolean>>(
        {},
    );
    const [data, updateData] = useState<unknown>(null);

    const openDialog = (name: string, data: unknown) => {
        if (data) {
            updateData(data);
        }

        setDialogIsOpen((prevState) => ({
            ...prevState,
            [name]: true,
        }));
    };

    const closeDialog = (name: string) => {
        setDialogIsOpen((prevState) => ({
            ...prevState,
            [name]: false,
        }));

        setTimeout(() => updateData(null), 100);
    };

    const isDialogOpen = (name: string) => !!dialogIsOpen[name];

    const getDialogData = () => data;

    return (
        <DialogContext.Provider
            value={{ getDialogData, openDialog, closeDialog, isDialogOpen }}>
            {children}
        </DialogContext.Provider>
    );
};

export const useDialog = (): DialogContextType => {
    const context = useContext(DialogContext);
    if (!context) {
        throw new Error('useDialog must be used within a DialogProvider');
    }
    return context;
};
